import {
  Backdrop,
  Box,
  Button,
  Grid,
  styled,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { LoadingOverlay2 } from "./LoadingOverlay-2";
import { useRecoilValue } from "recoil";
import { fotoProfileUrlState } from "../recoil/UserFotoProfileState";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "60%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
    width: "90%",
  },
  margin: "1%",
}));

const FullText = styled(Typography)(({ theme }) => ({
  width: "60%",
  margin: "3%",
  wordWrap: "break-word",
  textAlign: "center",
}));

const MarginButton = styled(Button)(({ theme }) => ({
  marginBottom: "3%",
}));

const FullButton = styled(Button)(({ theme }) => ({
  width: "20%",
  [theme.breakpoints.down("md")]: {
    width: "25%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "30%",
  },
  margin: "3%",
}));

export interface IInputFileModalProps {
  open: boolean;
  uploaded: boolean;
  handleClose: () => void;
  handleSave: (e: any) => void;
  inputAccept: string;
  text: string;
  isLoading?: boolean;
}

export function InputFileModal(props: IInputFileModalProps) {
  const [file, setFile] = useState<File | undefined>(undefined);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const currentPhotoUrl = useRecoilValue(fotoProfileUrlState);

  useEffect(() => {
    if (!props.open) {
      setFile(undefined);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [props.open]);

  const handleFile = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleOpenCurrentFileTab = () => {
    if (file) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
    } else if (currentPhotoUrl) {
      window.open(currentPhotoUrl, "_blank");
    }
  };

  const handleOpenFileTab = () => {
    if (props.uploaded) {
      window.open(`${window.location.origin}/File/${props.text}`);
    }
  };

  const isFotoModal = props.text === "Foto";
  const hasExistingFile = props.uploaded || (isFotoModal && !!currentPhotoUrl);
  const hasPreview = !!file || (isFotoModal && hasExistingFile);

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.open}
    >
      <LoadingOverlay2 isLoading={props.isLoading ?? false}>
        <SquareGrid container>
          <Grid container justifyContent="flex-start" item xs={6}>
            <Typography variant="h5" color="black">
              {props.text}
            </Typography>
          </Grid>
          <Grid container justifyContent="flex-end" item xs={6}>
            <Button
              onClick={props.handleClose}
            >
              Close
            </Button>
          </Grid>
          <Grid container justifyContent="center" item xs={12}>
            <FullText color="error">
              {props.inputAccept === ".jpg, .jpeg, .png"
                ? "PNG or JPG only ( Maximum File Size : 5MB )"
                : "PDF or PNG or JPG only ( Maximum File Size : 5MB )"}
            </FullText>
          </Grid>
          <Grid container justifyContent="center" item xs={12}>
            <Grid container justifyContent="center" item xs={12}>
              {props.text === "CV" ||
                props.text === "Ijazah" ||
                props.text === "TranskripNilai" ? (
                props.uploaded ? (
                  <MarginButton onClick={handleOpenFileTab}>
                    Lihat File Yang&nbsp;
                    <Typography sx={{ fontWeight: "bold" }}> Sudah </Typography>
                    &nbsp; Di Submit
                  </MarginButton>
                ) : (
                  <FullText color="black">Mohon Untuk Upload File</FullText>
                )
              ) : (
                hasPreview ? (
                  <Box
                    component="img"
                    src={
                      file
                        ? URL.createObjectURL(file)
                        : currentPhotoUrl || ""
                    }
                    sx={{
                      height: "16vh",
                      width: "16vh",
                      borderRadius: "50%",
                      objectFit: "cover",
                      marginBottom: "3%",
                      backgroundColor: !file && !currentPhotoUrl ? '#f0f0f0' : 'transparent',
                    }}
                  />
                ) : (
                  <FullText color="black">Mohon Untuk Upload File</FullText>
                )
              )}
            </Grid>
            <Grid container justifyContent="center" item xs={12}>
              {file !== undefined && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: "3%",
                  }}
                > {props.text === "CV" ||
                  props.text === "Ijazah" ||
                  props.text === "TranskripNilai" ? (
                  <Button onClick={handleOpenCurrentFileTab}>
                    Lihat File Yang&nbsp;
                    <Typography sx={{ fontWeight: "bold" }}> Akan </Typography>
                    &nbsp; Di Upload
                  </Button>
                ) : null}
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    {file.name}
                  </Typography>
                </Box>
              )}
            </Grid>
            <Grid container justifyContent="center" item xs={12}>
              <Button variant="outlined" component="label" disabled={props.isLoading}>
                Upload File
                <input
                  ref={fileInputRef}
                  type="file"
                  accept={props.inputAccept}
                  hidden
                  onChange={handleFile}
                />
              </Button>
            </Grid>
          </Grid>
          <Grid container justifyContent="center" item xs={12}>
            <FullButton
              variant="contained"
              disabled={!file || props.isLoading}
              onClick={() => {
                if (file) props.handleSave(file);
              }}
              sx={{ whiteSpace: "nowrap" }}
            >
              Save File
            </FullButton>
          </Grid>
        </SquareGrid>
      </LoadingOverlay2>
    </Backdrop >
  );
}